import GridKeikkaEditor_Teksti_Row from "../../teksti/GridKeikkaEditor_Teksti_Row";
import PropTypes from "prop-types";

export default function GridKeikkaEditor_Teksti_Pumppaus({ subText, keikkaState }) {
  return (
    <GridKeikkaEditor_Teksti_Row title="Pumppaus" gray phone={keikkaState?.pumppuAsiakasPhone}>
      {subText(keikkaState?.pumppuAsiakasNimi)}
      {subText(
        (keikkaState.vehicleTypeId == 2 ? "Pumi " : "") +
          (keikkaState.vehicleTypeId == 3 ? "Pumppu " : "") +
          keikkaState?.pumppuPuomi +
          " metrin puomilla"
      )}
      {keikkaState?.pumppuLinja && subText(keikkaState?.pumppuLinja + " metriä linjaa")}
    </GridKeikkaEditor_Teksti_Row>
  );
}

GridKeikkaEditor_Teksti_Pumppaus.propTypes = {
  subText: PropTypes.func,
  keikkaState: PropTypes.object,
};
